/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../services/api.js';
import { isValidEmail } from '../utils/validation.js';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!email) return;

    if (!isValidEmail(email)) {
      setError('Por favor, insira um e-mail válido.');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Erro ao enviar email de recuperação.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
        py: 4,
      }}
    >
      <Container maxWidth='sm'>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <Typography
            component='h1'
            variant='h5'
            sx={{ mb: 3, fontWeight: 'bold', color: '#1a1a1a' }}
          >
            Esqueceu sua senha?
          </Typography>

          {!success ? (
            <>
              <Typography
                variant='body1'
                color='text.secondary'
                align='center'
                sx={{ mb: 4 }}
              >
                Digite seu email abaixo e enviaremos um link para redefinir sua
                senha.
              </Typography>

              <Box
                component='form'
                onSubmit={handleSubmit}
                sx={{ width: '100%' }}
              >
                <TextField
                  margin='normal'
                  required
                  fullWidth
                  id='email'
                  label='Email'
                  name='email'
                  autoComplete='email'
                  autoFocus
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={loading}
                />

                {error && (
                  <Alert severity='error' sx={{ mt: 2 }}>
                    {error}
                  </Alert>
                )}

                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  sx={{ mt: 3, mb: 2, py: 1.5, fontWeight: 'bold' }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} />
                  ) : (
                    'Enviar Link de Recuperação'
                  )}
                </Button>

                <Button
                  fullWidth
                  variant='text'
                  onClick={() => navigate('/login')}
                  disabled={loading}
                  sx={{ mt: 1 }}
                >
                  Voltar para Login
                </Button>
              </Box>
            </>
          ) : (
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              <Alert severity='success' sx={{ mb: 3 }}>
                Email enviado com sucesso! Verifique sua caixa de entrada.
              </Alert>
              <Button
                variant='outlined'
                onClick={() => navigate('/login')}
                fullWidth
              >
                Voltar para Login
              </Button>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;
